import React from 'react';
import { Button } from '@milanlaser/mlcomponents';
import textIcon from '../../images/share/text-icon.svg';
import { SiteEnvironment, useSiteMetadata } from '../../hooks/useSiteMetadata';

const PHONE_NUMBER_PROD = '+18336672967';
const PHONE_NUMBER_QA = '+18335353711';
const TEXT_PROMPT = `By hitting send, I agree to start texting with Milan Laser and agree to the Privacy Policy & Terms.`;
const SMS_TO_PROD = `sms:${PHONE_NUMBER_PROD}`;
const SMS_TO_QA = `sms:${PHONE_NUMBER_QA}`;
const SMS_BODY = `;?&body=${encodeURIComponent(TEXT_PROMPT)}`;
//Feature Flag for Link to Text
const isLinkToTextEnabled = process.env.GATSBY_LINK_TO_TEXT === 'true';

export function LinkToText() {
    const { data } = useSiteMetadata();

    const isQAorLocalEnv =
        data?.siteEnvironment === SiteEnvironment.QA || data?.siteEnvironment === SiteEnvironment.DEV;

    // Hide the component entirely if the feature flag is disabled
    if (!isLinkToTextEnabled) {
        return null;
    }

    return (
        <>
            <a
                href={`${isQAorLocalEnv ? SMS_TO_QA : SMS_TO_PROD}${SMS_BODY}`}
                style={{ textDecoration: 'none', position: 'fixed', right: 28, bottom: 24, zIndex: 1000 }}
                aria-label="Text Us"
            >
                <Button
                    className="mcl-bg-milan-navy flex flex-col justify-center items-center text-white p-2"
                    style={{ borderRadius: '50%', width: 56, height: 56, boxShadow: '0 4px 12px rgba(0,0,0,0.15)' }}
                >
                    <img src={textIcon} alt="Text Icon" style={{ width: 24, height: 24 }} />
                    <span className="text-[14px] font-regular">Text+</span>
                </Button>
            </a>
        </>
    );
}
